import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Compass, Download, Star, Bot, Webhook, Cpu, GitBranch, Send, Package } from 'lucide-react';
import { haptic } from '../../telegram';
import { marketplaceApi, type PublicListingCard } from '../../api/marketplaceApi';

const KIND_ICONS: Record<string, any> = { agent: Bot, mcp: Cpu, webhook: Webhook, pipeline: GitBranch };
const KIND_LABELS: Record<string, string> = { all: 'Все', agent: 'Агенты', pipeline: 'Сценарии', mcp: 'MCP', webhook: 'Вебхуки' };

export function Marketplace() {
  const nav = useNavigate();
  const [items, setItems] = useState<PublicListingCard[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [filter, setFilter] = useState<string>('all');
  const [search, setSearch] = useState('');

  useEffect(() => {
    marketplaceApi.getListings()
      .then((r) => { setItems(r || []); setLoading(false); })
      .catch(() => { setError(true); setLoading(false); });
  }, []);

  const filtered = items.filter((it) => {
    if (filter !== 'all' && it.kind !== filter) return false;
    if (search && !it.title.toLowerCase().includes(search.toLowerCase()) && !it.summary.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  return (
    <div className="rf-page">
      <div className="rf-ptitle rf-in">Маркет</div>
      <div className="rf-psub rf-in">Готовые сценарии и агенты. Установка в один тап.</div>

      <div className="rf-btn-row rf-in">
        {/* Публикация своих сценариев ещё не реализована: оставляем видимой, но неактивной. */}
        <button className="rf-btn primary" disabled title="Функция в разработке"><Send />Опубликовать · скоро</button>
        <button className="rf-btn" onClick={() => { haptic('light'); nav('/marketplace/mine'); }}><Package />Мои листинги</button>
      </div>

      <input className="rf-input rf-in rf-mb12" placeholder="Поиск…" value={search} onChange={(e) => setSearch(e.target.value)} />

      <div className="rf-seg rf-in">
        {Object.entries(KIND_LABELS).map(([key, label]) => (
          <button key={key} className={'rf-seg-btn' + (filter === key ? ' active' : '')} onClick={() => { haptic('light'); setFilter(key); }}>{label}</button>
        ))}
      </div>

      {loading ? (
        <div className="rf-loading"><div className="rf-spin" /><p>Загрузка…</p></div>
      ) : error ? (
        <div className="rf-empty"><div className="rf-empty-ic"><Compass /></div><h3>Ошибка загрузки</h3><p>Попробуйте позже</p></div>
      ) : filtered.length === 0 ? (
        <div className="rf-empty"><div className="rf-empty-ic"><Compass /></div><h3>Ничего не найдено</h3><p>Измените фильтр или запрос</p></div>
      ) : (
        <div className="rf-rows rf-stagger">
          {filtered.map((it) => {
            const Icon = KIND_ICONS[it.kind] || Compass;
            return (
              <div key={it.id} className="rf-card rf-acard rf-click" onClick={() => { haptic('light'); nav('/marketplace/' + it.id); }}>
                <div className="rf-acard-head">
                  <div className="rf-row-ic"><Icon /></div>
                  <div className="rf-acard-info">
                    <div className="rf-acard-name">{it.title}{it.is_system && <Star className="rf-star" />}</div>
                    <div className="rf-acard-desc">{it.summary}</div>
                  </div>
                </div>
                <div className="rf-tags">
                  <span className="rf-tag">{it.installs_count} установок</span>
                  <span className="rf-tag">{KIND_LABELS[it.kind] || it.kind}</span>
                  {it.category && <span className="rf-tag">{it.category}</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
